const Blobs = () => {
    return (
        <>
            <div className="hero-blob hero-blob--tl" aria-hidden="true" />
            <div className="hero-blob hero-blob--tr" aria-hidden="true" />
            <div className="hero-blob hero-blob--br" aria-hidden="true" />
        </>
    );
};

export default Blobs;

